var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_211_2125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 37.7C69 43.9301 67.1525 50.0203 63.6913 55.2004C60.23 60.3806 55.3104 64.418 49.5545 66.8022C43.7987 69.1863 37.4651 69.8101 31.3547 68.5947C25.2443 67.3793 19.6314 64.3792 15.2261 59.9738C10.8207 55.5685 7.82074 49.9557 6.6053 43.8453C5.38987 37.7349 6.01358 31.4013 8.39774 25.6454C10.7819 19.8895 14.8193 14.9699 19.9995 11.5087C25.1796 8.04739 31.2699 6.19995 37.5 6.19995C45.8543 6.19995 53.8664 9.51869 59.7738 15.4261C65.6812 21.3335 69 29.3456 69 37.7Z",
    fill: "white",
    stroke: "#29AF88",
    strokeWidth: 2.72727
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2065 37.7054H52.7806",
    stroke: "#29AF88",
    strokeWidth: 4.09091,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4941 22.0741V53.3341",
    stroke: "#29AF88",
    strokeWidth: 4.09091,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_211_2125",
    x: 0.545321,
    y: 0.745394,
    width: 82.0912,
    height: 82.0909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.09091,
    dy: 4.09091
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.09091
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.251 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_211_2125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_211_2125",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTask);
export default __webpack_public_path__ + "static/media/AddTask.c15cb6b76cb77f0dc7bcc6cbce9b0558.svg";
export { ForwardRef as ReactComponent };